import { useEffect } from 'react';
import type React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useSharingModal } from './hooks/useSharingModal';
import type { SharingModalProps } from './types';

export const SharingModal: React.FC<SharingModalProps> = (props) => {
	const { translate } = useI18n();
	const {
		data: {
			modalTitle,
			modalDescription,
			primaryCTA,
			secondaryCTA,
			iconComponent,
			nextStepsComponent,
			postPreviewComponent,
		},
		actions: { primaryAction, secondaryAction, trackView },
	} = useSharingModal(props);

	const { defaultOpen, onClose } = props;
	const handleClose = onClose ?? (() => {});

	useEffect(() => {
		if (defaultOpen) trackView();
	}, [defaultOpen, trackView]);

	return (
		<Modal
			defaultOpen={defaultOpen}
			isDismissable
			onClose={handleClose}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			data-testid="sharing-modal"
			size="large"
			className="z-30 md:[&>div>div]:max-h-[750px]!"
			onOpenChange={(isOpen) => {
				if (!isOpen) {
					handleClose();
				}
			}}
		>
			<ModalHeader title={modalTitle} subtitle={modalDescription} leadingSlot={iconComponent} />
			<ModalBody className="pt-2">
				<div className="flex w-full flex-col gap-6 md:flex-row md:gap-8">
					<div className="flex-1">{postPreviewComponent}</div>
					<div className="flex-1">{nextStepsComponent}</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={primaryAction}
					variant="primary"
					data-testid="primary-action"
					data-qa="sharing-modal-primary-action"
				>
					{primaryCTA}
				</Button>
				{secondaryAction && (
					<Button onClick={secondaryAction} data-testid="secondary-action" data-qa="sharing-modal-secondary-action">
						{secondaryCTA}
					</Button>
				)}
			</ModalFooter>
		</Modal>
	);
};
